module.exports = __webpack_public_path__ + "static/media/no-photo-placeholder.489764d8.svg";